// Full-document render of the pillows ProductFilterGridPage: PageSkeleton (the
// React document shell) wrapping ProductFilterGridPageBody, which renders the
// category list, hero, hero sidekick, top banner, category header and page
// body in the same order as the legacy tempur.html layout block.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductFilterGridPageBody } from "../components/ProductFilterGridPageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
export const Template = (
    props: templates.ProductFilterGridPageTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ProductFilterGridPageBody {...props} />
        </PageSkeleton>
    );
};
